<script setup>
// Fork JavaMifi: pilih organisasi (BU) pemilik sebuah item. Hanya administrator yang memilih;
// admin organisasi tidak melihat pilihan ini karena server selalu memakai organisasinya.
import { onMounted, ref } from 'vue';
import { useAdmin } from 'dashboard/composables/useAdmin';
import OrganizationsAPI from 'dashboard/api/organizations';

const modelValue = defineModel({ type: Number, default: null });

const { isAdmin } = useAdmin();
const organizations = ref([]);

onMounted(async () => {
  if (!isAdmin.value) return;
  const { data } = await OrganizationsAPI.get();
  organizations.value = data.organizations;
});
</script>

<template>
  <label v-if="isAdmin" class="w-full">
    {{ $t('ORGANIZATION_MGMT.SELECT.LABEL') }}
    <select
      :value="modelValue ?? ''"
      data-testid="organization-select"
      @change="modelValue = $event.target.value ? Number($event.target.value) : null"
    >
      <option value="">{{ $t('ORGANIZATION_MGMT.SELECT.SHARED') }}</option>
      <option
        v-for="organization in organizations"
        :key="organization.id"
        :value="organization.id"
      >
        {{ organization.name }}
      </option>
    </select>
  </label>
</template>
